import React from "react";
import Common_Banner from "../Common_Components/Common_Heading/Common_Banner/Common_Banner";
import Our_Story from "./Our_Story/Our_Story";
import OurCommitment from "./Our_Commitment/Our_Commitment";
import MissionVisionValues from "./Vision_Mission/Vission_Mission";
import Certificate from "../Home/Certificate/Certificate";
import ReadyToStart from "../Home/Ready_To_Start/Ready_To_Start";
import WhyChooseUs from "../Home/Why_Choose_Us/Why_Choose_Us";
import GlobalCareerCTA from "../Home/GlobalCareerCTA/GlobalCareerCTA";

function NewAbout() {
  return (
    <>
      <Common_Banner
        image="/assets/images/home/hero_city_buildings.jpg"
        title="About Kaumodaki"
        subtitle="Your trusted partner in global manpower recruitment"
      />

      <Our_Story />

      <OurCommitment />

      <MissionVisionValues />

      <Certificate />
      <WhyChooseUs />

      <ReadyToStart />
      <GlobalCareerCTA />
    </>
  );
}

export default NewAbout;
